__turbopack_context__.v({
  "ApplyNow_Custom": "NavWithScrollLandingPageMBA-module-scss-module__fivzQq__ApplyNow_Custom",
  "NavWithScroll__cardContainer": "NavWithScrollLandingPageMBA-module-scss-module__fivzQq__NavWithScroll__cardContainer",
  "NavWithScroll__listContainer": "NavWithScrollLandingPageMBA-module-scss-module__fivzQq__NavWithScroll__listContainer",
  "NavWithScroll__selectedLink": "NavWithScrollLandingPageMBA-module-scss-module__fivzQq__NavWithScroll__selectedLink",
});
